/**
 * Map of all Contentful marks.
 */
enum MARKS {
  BOLD = 'bold',
  ITALIC = 'italic',
  UNDERLINE = 'underline',
  CODE = 'code',
}

export default MARKS;
